import React, { useState } from "react";
import { StyleSheet, SafeAreaView, View, Image, Text } from "react-native";
import { useNavigation } from "@react-navigation/native";
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { FIREBASE_AUTH } from "../firebaseConfig";
import CustomButton from "../components/customComponents/CustomButton";
import CustomInput from "../components/customComponents/CustomInput";
import { requireEmail, requireText } from "../constant/commonRules";
import { useForm } from "react-hook-form";
import { languageSignInDict } from "../constant/LanguageDict";
import { ScrollView } from "react-native";
const auth = FIREBASE_AUTH;

export default function SignInScreen() {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigation = useNavigation();

  const { control, handleSubmit } = useForm();

  const onSignInPressed = async (data) => {
    if (loading) {
      return;
    }
    const { password, email } = data;
    setLoading(true);
    const auth = FIREBASE_AUTH;
    try {
      await signInWithEmailAndPassword(auth, email, password);
      errorMessage && setErrorMessage("");
      // navigate to home-page
    } catch (error) {
      if (error.code === "auth/wrong-password") {
        setErrorMessage(languageSignInDict["Password isn't correct"]);
      }
      if (error.code === "auth/user-not-found") {
        setErrorMessage(languageSignInDict["Email doesn't exist"]);
      }
      if (error.code === "auth/invalid-login-credentials") {
        setErrorMessage(languageSignInDict["Email or password doesn't exist"]);
      }
    }
    setLoading(false);
  };

  const onForgotPasswordPressed = () => {
    navigation.navigate("ForgotPassword");
  };

  const onSignUpPress = () => {
    navigation.navigate("SignUp");
  };
  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: "#e8ecf4" }}>
      <ScrollView style={styles.container}>
        <View
          className="w-full  lg:w-7/12 xl:w-6/12"
          style={{ margin: "auto" }}
        >
          <View style={styles.header}>
            <Image
              alt="icon"
              resizeMode="contain"
              style={styles.headerImg}
              source={require("./../assets/icon/512purple.png")}
            />

            <Text style={styles.title}>
              {languageSignInDict["Sign in to"]} {languageSignInDict["MyApp"]}
            </Text>

            <Text style={styles.subtitle}>
              {languageSignInDict["Get access to your portfolio and more"]}
            </Text>
          </View>

          <View style={styles.form}>
            <CustomInput
              name="email"
              keyboardType="email-address"
              control={control}
              placeholder={languageSignInDict["email-address"]}
              rules={requireEmail(languageSignInDict["email-address"])}
              subtitle={languageSignInDict["email-address"]}
            />
            <CustomInput
              name="password"
              placeholder={languageSignInDict["Password"]}
              control={control}
              secureTextEntry
              subtitle={languageSignInDict["Password"]}
              rules={requireText(languageSignInDict["Password"])}
            />
            <Text className="text-red-500">{errorMessage}</Text>

            <CustomButton
              text={
                loading
                  ? languageSignInDict["Loading..."]
                  : languageSignInDict["Sign In"]
              }
              onPress={handleSubmit(onSignInPressed)}
            />

            <CustomButton
              text={languageSignInDict["Forgot password?"]}
              onPress={onForgotPasswordPressed}
              type="TERTIARY"
              link={true}
            />

            <CustomButton
              text={languageSignInDict["Don't have an account? Create one"]}
              onPress={onSignUpPress}
              type="TERTIARY"
              link={true}
            />
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 24,
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
  },
  subContainer: {
    width: 700,
    margin: "auto",
  },
  header: {
    marginVertical: 36,
  },
  headerImg: {
    width: 80,
    height: 80,
    alignSelf: "center",
    marginBottom: 36,
  },
  title: {
    fontSize: 27,
    fontWeight: "700",
    color: "#7572ff",
    marginBottom: 6,
    textAlign: "center",
  },
  subtitle: {
    fontSize: 15,
    fontWeight: "500",
    color: "#929292",
    textAlign: "center",
  },
  form: {
    marginBottom: 24,
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
  },
  formAction: {
    marginVertical: 24,
  },
  formFooter: {
    fontSize: 17,
    fontWeight: "600",
    color: "#222",
    textAlign: "center",
    letterSpacing: 0.15,
  },
  input: {
    marginBottom: 16,
  },
  inputLabel: {
    fontSize: 17,
    fontWeight: "600",
    color: "#222",
    marginBottom: 8,
  },
  inputControl: {
    height: 44,
    backgroundColor: "#fff",
    paddingHorizontal: 16,
    borderRadius: 12,
    fontSize: 15,
    fontWeight: "500",
    color: "#222",
  },
  btn: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderWidth: 1,
    backgroundColor: "#075eec",
    borderColor: "#075eec",
  },
  btnText: {
    fontSize: 18,
    lineHeight: 26,
    fontWeight: "600",
    color: "#fff",
  },
  formActionSpacer: {
    marginVertical: 32,
    fontSize: 14,
    fontWeight: "600",
    color: "#4b4858",
    textAlign: "center",
  },
});
